import React from "react";
import { Spin } from "antd";

export const FullscreenSpinner = ({ tip = "Loading..." }) => (
    <div
        style={{
            display: "flex",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <Spin tip={tip} />
    </div>
);